import api from "./api";

export async function getClients(params) {
  const res = await api.get("/customer", { params });
  return res.data.data;
}